<template>
    <v-container fluid class="page-container">
        <page-header title="Cards" :subtitle="totalLabel">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New card
            </v-btn>
        </page-header>

        <filter-panel
            :fields="filterFields"
            :value="listState"
            :loading="loading"
            @apply="applyFilters"
        />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No cards match these filters"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.number`]="{ item }">
                    <span class="font-weight-medium">{{ item.number }}</span>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <v-chip x-small outlined>{{ item.type }}</v-chip>
                    <v-chip v-if="item.vip" x-small color="amber lighten-4" class="ml-1">VIP</v-chip>
                </template>
                <template v-slot:[`item.member`]="{ item }">{{ memberName(item.member) }}</template>
                <template v-slot:[`item.expirationDate`]="{ item }">
                    <span :class="{ 'error--text': isExpired(item.expirationDate) }">{{ formatDate(item.expirationDate) }}</span>
                </template>
                <template v-slot:[`item.active`]="{ item }">
                    <v-chip small :outlined="!item.active" :color="item.active ? 'success' : 'grey'">
                        {{ item.active ? 'Active' : 'Inactive' }}
                    </v-chip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button title="Delete this card?" @delete-entry="deleteItem(item, deleteCard, 'Card')" />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import cardService from '@/services/card-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'
    import { formatDate, fullName } from '@/utils/format'

    export default {
        name: 'CardRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                filterFields: [
                    { key: 'member', label: 'Member', placeholder: 'First or last name' },
                    { key: 'number', label: 'Card number', placeholder: 'Exact number' },
                    { key: 'active', label: 'Active', type: 'boolean' }
                ],
                headers: [
                    { text: 'Number', value: 'number' },
                    { text: 'Type', value: 'type' },
                    { text: 'Member', value: 'member' },
                    { text: 'QR', value: 'qr' },
                    { text: 'Expires', value: 'expirationDate' },
                    { text: 'Status', value: 'active' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        methods: {
            formatDate,
            fetchPage({ page, perPage, filters, sortOption, order }) {
                return cardService.getCardsByFilter(page, filters, sortOption, order, perPage)
            },
            deleteCard: id => cardService.deleteCardById(id),
            memberName(member) {
                return member && typeof member === 'object' ? fullName(member) : ''
            },
            isExpired(date) {
                return !!date && moment(date).isBefore(moment(), 'day')
            }
        }
    }
</script>
